import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { itemHistoryService } from "@/services/item-history";

// Fetched only while the history dialog is open (id is null otherwise).
export function useProductPriceHistory(productId: string | null) {
  return useQuery({
    queryKey: queryKeys.itemHistory.productPrice(productId ?? ""),
    queryFn: () => itemHistoryService.productPrice(productId ?? ""),
    enabled: !!productId,
  });
}

export function useProductCostHistory(productId: string | null) {
  return useQuery({
    queryKey: queryKeys.itemHistory.productCost(productId ?? ""),
    queryFn: () => itemHistoryService.productCost(productId ?? ""),
    enabled: !!productId,
  });
}

export function useRawMaterialCostHistory(rawMaterialId: string | null) {
  return useQuery({
    queryKey: queryKeys.itemHistory.rawMaterialCost(rawMaterialId ?? ""),
    queryFn: () => itemHistoryService.rawMaterialCost(rawMaterialId ?? ""),
    enabled: !!rawMaterialId,
  });
}
